export const bangGia = {
  sections: {
    list: { title: '价格表' },
    setup: { title: '价格设置' },
    bookList: { title: '价格表' },
    quanLy: { title: '价格表管理' },
    thietLap: { title: '价格表设置' },
  },
  tabs: {
    info: '信息',
    scope: '适用范围',
    books: '价格表',
    products: '商品价格',
  },
  fields: {
    code: '编码',
    name: '名称',
    startDate: '开始日期',
    endDate: '结束日期',
    status: '状态',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    onOffAction: '启停',
    actions: '操作',
    formulaBase: '基价',
    formulaOp: '运算',
    formulaValue: '数值',
    formulaUnit: '单位',
    allowOutOfCatalog: '允许目录外商品',
    warnOutOfCatalog: '目录外提醒',
    branches: '适用门店',
    productCode: '商品编码',
    productName: '商品名称',
    unit: '单位',
    productGroup: '商品分组',
    costPrice: '成本价',
    lastPurchasePrice: '最近进价',
    commonPrice: '通用价格表',
    salePrice: '售价',
    stock: '库存',
  },
  sections2: {
    validity: '有效期',
    formula: '价格公式',
    formulaDesc: '基于成本价、末次进价或其他价格表的售价创建公式',
    cashier: '收银员使用此价格表下单时',
    scopeBranch: '门店',
    scopeCustomerGroup: '客户分组',
    scopeCreator: '创建人',
  },
  placeholders: {
    name: '输入价格表名称',
    branch: '选择门店',
    customerGroup: '选择客户分组',
    creator: '选择创建人',
    search: '搜索',
    selectPriceBook: '选择价格表',
  },
  radio: {
    all: '全部',
    specific: '特定',
    branchAllSystem: '全系统',
    branchSpecific: '指定门店',
    customerGroupAll: '全部',
    customerGroupSpecific: '指定客户分组',
    creatorAll: '全部',
    creatorSpecific: '指定创建人',
    allowOutOfCatalog: '允许添加价格表外的商品',
    warnWhenOutOfCatalog: '添加价格表外的商品时提示',
    onlyInCatalog: '仅允许添加价格表内的商品',
    apDung: '已应用',
    chuaApDung: '未应用',
  },
  formula: {
    baseEquals: '新价 =',
    to: '至',
    add: '加',
    remove: '减',
    selectPriceBook: '选择价格表',
    giaVon: '成本价',
    giaNhapCuoi: '末次进价',
    searchPlaceholder: '搜索',
  },
  status: {
    AP_DUNG: '已应用',
    CHUA_AP_DUNG: '未应用',
    all: '全部',
  },
  sort: {
    ma: '编码',
    ten: '名称',
    ngayTao: '创建时间',
  },
  filter: {
    searchPlaceholder: '编码或名称',
    statusSection: '状态',
    sortSection: '排序',
    sortField: '排序字段',
    sortDir: '方向',
    productSearch: '编码/名称',
    maHangHoa: '商品编码',
    tenHangHoa: '商品名称',
    maNhomHang: '分组编码',
    tenNhomHang: '分组名称',
    group: '商品组',
    stockSection: '库存',
    priceCompareSection: '价格比较',
  },
  tonKho: {
    TAT_CA: '全部',
    CON_HANG: '有货',
    HET_HANG: '缺货',
  },
  dieuKienGia: {
    NHO_HON: '小于',
    LON_HON: '大于',
    BANG: '等于',
    NHO_HON_HOAC_BANG: '≤',
    LON_HON_HOAC_BANG: '≥',
  },
  giaSoSanh: {
    GIA_VON: '成本价',
    GIA_NHAP_CUOI: '末次进价',
  },
  loaiGiaGoc: {
    GIA_VON: '成本价',
    GIA_NHAP_CUOI: '末次进价',
  },
  toanTu: {
    CONG: '加',
    TRU: '减',
    NHAN: '乘',
    CHIA: '除',
  },
  donVi: {
    VND: 'VND',
    PERCENT: '%',
  },
  titles: {
    add: '新增价格表',
    edit: '编辑价格表',
    detail: '价格表详情',
    priceList: '表内商品价',
    editPrice: '修改售价',
    applyFormula: '应用价格公式',
  },
  actions: {
    skip: '跳过',
    save: '保存',
    downloadTemplate: '下载 Excel 模板',
    importPrice: '导入价格 (Excel)',
    exportPrice: '导出价格 (Excel)',
    applyFormula: '应用公式',
    toggleColumns: '显示/隐藏列',
  },
  aria: {
    columnPicker: '选择显示列',
  },
  columnSections: {
    productInfo: '商品信息',
    priceBooks: '价格表',
  },
  messages: {
    noData: '暂无数据',
    loadError: '加载失败',
    loadDetailError: '无法加载详情',
    createSuccess: '已创建',
    updateSuccess: '已更新',
    deleteSuccess: '已删除',
    toggleSuccess: '状态已更新',
    priceUpdateSuccess: '售价已更新',
    formulaSuccess: '已应用公式',
    importSuccess: '导入成功',
    importFailed: '导入价格失败',
    importEmpty: '文件中没有价格数据行',
    importNoSheet: 'Excel 文件没有数据表',
    importDescription:
      '下载模板（商品编码、名称、可选通用价 + 价格表列）。文件中尚不存在的价格表会按名称自动创建。空单元格跳过。',
    exportSuccess: '正在下载',
    confirmDelete: '删除价格表「{name}」？',
    listSummary: '共 {count} 个价格表',
    gridSummary: '{count} 个商品',
    selectBook: '请在左侧选择价格表以查看和编辑价格。',
    noPriceBooks: '尚无价格表。请先添加价格表再设置商品价格。',
    multiBookHint: '当前显示 {count} 个价格表 — 每个价格表为一列价格。第一个价格表用于分页。',
    confirmApplyFormula: '对表中全部商品应用自动价格公式？',
    nameRequired: '请输入价格表名称',
    nameDuplicate: '价格表名称已存在',
    formulaRequired: '请选择基价',
    dateRangeInvalid: '结束日期必须晚于开始日期',
    scopeBranchRequired: '请选择适用门店',
  },
  cellPrice: {
    applyThisOnly: '对此商品应用公式',
    applyPage: '对本页全部商品编码应用公式',
    applyAll: '对全部商品编码应用公式',
    computeFromFormula: '按公式计算价格',
    apply: '应用',
  },
  tooltips: {
    onlyInCatalogHint: '开启后，收银员只能选择价格表内的商品。表外商品在前台会被隐藏/置灰。',
  },
}
